import React from 'react'
import styled from 'styled-components'

import {Paper, Button} from 'components'
import Checkbox from '@mui/material/Checkbox';
import { withStyles } from '@material-ui/core/styles';

const CustomCheckbox = withStyles({
    root: {
        '&$checked': {
            color: 'var(--focus-color)',
        },
    },
    checked: {},
})(Checkbox)

const defaultStyle = {
    backgroundColor: 'var(--secondary-color)',
    titleSize: '1rem',
    subtitleSize: '0.9rem',
    buttonFontSize: null,
    border: null,
    boxShadow: null,
    maxWidth: null,
    padding: '0.5rem'
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.styles.backgroundColor};
    padding: ${props => props.styles.padding};
    border-radius: 5px;
    border: ${props => props.styles.border};
    box-shadow: ${props => props.styles.boxShadow};
    max-width: ${props => props.styles.maxWidth};
`

const Title = styled.div`
    font-weight: bold;
    font-size: ${props => props.styles.titleSize};
    text-align: center;
`

const Subtitle = styled.div`
    font-size: 0.9rem;
    /* width: 80%; */
    text-align: center;
`

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding: 0.5rem 0 0 0;
    justify-content: flex-start;
    align-items: center;
`

const CheckContainer = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 0.1rem;
    align-items: center;
`

const DeleteDialogue = props => {
    const {
        onDelete,
        closeHandler,
        closeHandler2,
        submitText,
        cancelText,
        warningText,
        subtitle,
        styles,
        checkbox=false
    } = props;
    const updatedStyle = Object.assign({}, defaultStyle, styles)
    const [checked, setChecked] = React.useState(true)

    const onDeleteHandler = (event) => {
        onDelete(checked)
        // closeHandler && closeHandler(event)
        // closeHandler2 && closeHandler2(event)
    }

    return (
        // <Paper>
            <Container styles={updatedStyle}>
                <Title styles={updatedStyle}>{warningText || 'Are you sure?'}</Title>
                {subtitle && <Subtitle>{subtitle}</Subtitle>}
                {checkbox &&
                <CheckContainer>
                    <CustomCheckbox size='small' defaultChecked={true} onChange={() => setChecked(!checked)}/>
                    <Subtitle>Delete items</Subtitle>
                </CheckContainer>}
                <ButtonContainer>
                    <Button text={submitText || 'Delete'} styles={{backgroundColor:'var(--focus-color)', color: 'white', margin:'0 0 0 0.5rem'}}
                        onSelect={onDeleteHandler}/>
                    <Button text={cancelText || 'Cancel'} styles={{backgroundColor:'var(--secondary-color)' ,margin:'0 0 0 0.5rem', boxShadowColor: 'transparent'}}
                        onSelect={closeHandler}/>
                </ButtonContainer>
            </Container>
        // </Paper>
    )
}

export default DeleteDialogue